import React, {useState, useEffect}  from 'react';
import * as ServerComms from '../utilities/ServerComms';
import ImageGrid from '../ImageGrid';

function App(props) {

  var entityName = props.entityName;

  var width = props.width;
  var nos = props.nos;
  var addWhereText = props.addWhereText;
  var currentImageUrl = props.currentImageUrl;
  var clickImage = props.clickImage;

  const [images, setImages] = useState([]);
  const [haveLoaded,setHaveLoaded] = useState(false);
  const [currentValue, setCurrentValue] = useState("");

  function refreshImages(){
    function postGetImages(response){
      if (response.t === 'list'){
        setImages(response.v.sort(() => (Math.random() > .5) ? 1 : -1));
        setHaveLoaded(true);

      }
    }
    ServerComms.fetchSomething({u:'getGenericImagesOrVideos', entityName}, postGetImages);
  }
  useEffect(() => {
    refreshImages();
   }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function changeValue(e){
    setCurrentValue(e.target.value)
  }
//
  var loadPiece;
  if (haveLoaded){  
    var lower = currentValue.toLowerCase();

    var filteredImages = images.filter((anImage, index)=>{
      return currentValue === '' || anImage.v[5].v.indexOf(lower) > -1;
    })

    loadPiece = <ImageGrid clickImage={clickImage} width={width} nos={nos} currentImageUrl={currentImageUrl} filteredImages={filteredImages} clickDelete={false}/>

  }else{
    loadPiece = <div>Loading...</div>
  }
//
  var headerPiece;
  if (addWhereText){
    headerPiece = <p className="lead mb-0">Add to {addWhereText}</p>
  }
  //      
  return (<div style={{textAlign:"center"}}><br/>{headerPiece}<input id='inputP' autoComplete="none" autoFocus type="text" className="inputBoxClass" placeholder="Search" value={currentValue} onChange={changeValue} /><br/><br/><center>
    {loadPiece}
    </center></div>)
//
}


export default App;
